import { loadOnce } from '../../app/chunks'

/** The voice recorder is a chunk of its own, fetched the first time the mic is tapped (or a recording is shown again). */
export const voiceRecorderSource = {
  load: () => import('./VoiceRecorder'),
}

/** Loads the recorder once. After a failure (offline, or an update replaced the chunk) the next tap tries again. */
export const loadVoiceRecorder = loadOnce(voiceRecorderSource)
